import { createAction } from '@reduxjs/toolkit';
import { addNamespace } from '@Utils/actions';

export const refreshBulkUploadSessionId = createAction(
	addNamespace('bulkupload/sessionId/refresh'),
);
